import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllPdQaqcResponse, PdQaqcDto, PdQaqcResponse } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Raw, Repository } from 'typeorm';
import { PeelingAdapter } from './dto/peeling.adapter';
import { PeelingDto } from './dto/peeling.dto';
import { PeelingIdRequest } from './dto/peeling-id-request';
import { Peeling } from './entities/peeling.entity';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { PeelingSamples } from './entities/peeling-samples.entity';
import { PeelingRepository } from './repositories/peeling.repository';
import appSettings from 'apps/services/config';
const peelingTable = appSettings.production_db + '.peeling'
const salesSoTable = appSettings.sales_db + '.sale_order';
const salesSoItemTable=appSettings.sales_db + '.sale_order_items'

@Injectable()
export class PeelingService {
    constructor(
        private peelingRepository: PeelingRepository,
        private peelingAdapter: PeelingAdapter,

    ) { }


    /**
     * 
     * @param testDto 
     * @param isUpdate 
     * @returns created Data
     */
    async getPeelingDetailsWithoutRelations(peelingId: number): Promise<Peeling> {
        // tslint:disable-next-line: typedef
        const peelingResponse = await this.peelingRepository.findOne({
            where: { peelingId: peelingId },
        });
        if (peelingResponse) {
            return peelingResponse;
        } else {
            return null;
        }
    }

    async createPeeling(PeelingDto: PeelingDto, isUpdate: boolean): Promise<PdQaqcResponse> {

        try {
            if (!isUpdate) {
                const PeelingEntity = await this.getPeelingDetailsWithoutRelations(PeelingDto.peelingId);
                if (PeelingEntity) {
                    //return new InformationMessageError(11104, "State already exists");
                    throw new ErrorResponse(11104, 'Peeling already exists');
                }
            }
            else {
                const PeelingEntity = await this.getPeelingDetailsWithoutRelations(PeelingDto.peelingId);
                if (PeelingEntity) {
                    if (PeelingEntity.peelingId != PeelingDto.peelingId) {
                        throw new ErrorResponse(11104, 'Peeling already exists');
                    }
                }
            }
            const convertedEntity: Peeling = this.peelingAdapter.convertDtoToEntity(PeelingDto);
            const savedEntity: Peeling = await this.peelingRepository.save(
                convertedEntity
            );

            if (savedEntity) {
                // generating resposnse
                const response = new PdQaqcResponse(true, 1, isUpdate ? 'Peeling Updated Successfully' : 'Peeling Created Successfully');
                return response;

            } else {
                //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
                throw new ErrorResponse(11106, 'Peeling saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }

    async getAllPeelings(): Promise<AllPdQaqcResponse> {
        try {
            const manager = getManager()
            const query = `SELECT s.saleOrder_Id as saleOrderId,s.saleorder_item_id as saleOrderItemId,s.peeling_date as peelingDate,s.peeling_id as peelingId,s.lot_number as lotNumber,so.sale_order_no as soNumber,  concat(b.brand_name, "/", p.name, "/", soi.min_grade_id,'-',soi.max_grade_id) as item FROM ` + peelingTable + ` s 
            LEFT JOIN ` + salesSoItemTable + ` soi ON soi.sale_order_item_id=s.saleorder_item_id 
            LEFT JOIN ` + salesSoTable + ` so ON so.sale_order_id=s.saleOrder_Id
            LEFT JOIN ` + appSettings.masters_db + `.brands b ON b.brand_id=soi.brand_id
            LEFT JOIN `+ appSettings.masters_db + `.products p ON p.product_id=soi.item_id
            LEFT JOIN `+ appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=soi.varient_id
            ORDER BY  peeling_id ASC` 
            const qEntities: PeelingDto[] = await manager.query(query)
            if (qEntities) {

                const response = new AllPdQaqcResponse(true, 1, 'Labelling retrieved successfully', qEntities);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            console.log(err)
            return err;
        }
    }
    async getAllActivePeelings(): Promise<AllPdQaqcResponse> {
        // const page: number = 1;
        try {
            const qDtos: PeelingDto[] = [];
            //retrieves all companies
            const qEntities: Peeling[] = await this.peelingRepository.find({
                order: { peelingId: 'ASC' },
            });
            console.log(qEntities)
            if (qEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                qEntities.forEach(Entity => {
                    const convertedDto: PeelingDto = this.peelingAdapter.convertEntityToDto(
                        Entity
                    );
                    qDtos.push(convertedDto);
                });
                const response = new AllPdQaqcResponse(true, 11108, "Peeling retrieved successfully", qDtos);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async activateOrDeactivatePeeling(qReq: PeelingIdRequest): Promise<PdQaqcResponse> {
        try {
            const qExists = await this.getPeelingById(qReq.peelingId);
            if (qExists) {
                if (qReq.versionFlag !== qExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Peeling information.Refresh and try again');
                } else {

                    const qStatus = await this.peelingRepository.update(
                        { peelingId: qReq.peelingId },
                        { isActive: qReq.isActive, updatedUser: qReq.updatedUser });

                    if (qExists.isActive) {
                        if (qStatus.affected) {
                            const peelingResponse: PdQaqcResponse = new PdQaqcResponse(true, 10115, 'Peeling is de-activated successfully');
                            return peelingResponse;
                        } else {
                            throw new ErrorResponse(10111, 'Peeling is already deactivated');
                        }
                    } else {
                        if (qStatus.affected) {
                            const peelingResponse: PdQaqcResponse = new PdQaqcResponse(true, 10114, 'Peeling is activated successfully');
                            return peelingResponse;
                        } else {
                            throw new ErrorResponse(10112, 'Peeling is already  activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getPeelingById(peelingId: number): Promise<Peeling> {
        const response = await this.peelingRepository.findOne({
            where: { peelingId: peelingId },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async createPeelingInfo(PeelingInfo: PeelingDto): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            console.log("test",PeelingInfo)
            const convertedDtoRmE = await this.peelingAdapter.convertDtoToEntity(PeelingInfo);
            await manager.startTransaction();
            const savedInfoRmE = await manager.getCustomRepository(PeelingRepository).save(convertedDtoRmE);

            if (savedInfoRmE) {
                manager.completeTransaction();
                return new CommonResponse(true, 1111, 'Peeling along with Samples Info are created successfully');
            } else {
                throw new ErrorResponse(9999, 'Creation of Peeling failed');
            }
        } catch (error) {
            manager.releaseTransaction();
            return error;
        }
    }

    async getAllPeelingSamplesForSamplesId(qReq: PeelingIdRequest): Promise<PdQaqcResponse> {
        try {
            const qDtos: PeelingDto[] = [];
            const qEntities: Peeling = await this.peelingRepository.findOne({ where: { peelingId: qReq.peelingId }, relations: ['PeelingSamplesInfo'] });

            if (qEntities) {
                const convertedDto: PeelingDto = this.peelingAdapter.convertEntityToLabelDto(
                    qEntities
                );
                const response = new PdQaqcResponse(true, 1, 'Peeling retrieved successfully', convertedDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            return err;
        }
    }

}
